import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class extends Controller {
	static targets = ["cover", "watch"]

	connect() {
		gsap.registerPlugin(ScrollTrigger)
		gsap.fromTo(
			this.watchTargets,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.75,
				stagger: {
					amount: 0.5,
					from: "center"
				},
				scrollTrigger: {
					trigger: this.coverTarget,
					start: "top 50%"
				}
			}
		)
	}
}
